// import { useEffect } from 'react'
import { AddComment, Clear, RateReview } from '@mui/icons-material'
import { IconButton } from '@mui/material'
import PropTypes from 'prop-types'
// import eventBus from '../../../lib/eventBus'
import { useDispatch } from 'react-redux'
import { openPopup } from '../../../store/popupsSlice'
import { useEffect } from 'react'
import eventBus from '../../../lib/eventBus'

const ExaminationRowActions = ({ setComment, row, deleteRow }) => {
  const dispatch = useDispatch()

  useEffect(() => {
    eventBus.on('examination-component-comment', (data) => {
      if (data.id == row.id) {
        setComment(data.comment)
      }
    })

    return eventBus.remove('examination-component-comment')
  }, [])

  return (
    <>
      <IconButton
        color="secondary"
        component="span"
        onClick={deleteRow}
        size="small"
      >
        <Clear />
      </IconButton>
      <IconButton
        title={`Edytuj komentarz`}
        size="small"
        onClick={() =>
          dispatch(
            openPopup({
              component: 'ExaminationComponentNoteFactory',
              title: 'Edytuj komentarz',
              level: 2,
              maxWidth: 'xl',
              values: {
                comment: row.comment,
                id: row.id,
              },
              key: 'examination-component-note-factory',
            })
          )
        }
      >
        {row.comment ? (
          <RateReview fontSize="small" />
        ) : (
          <AddComment fontSize="small" />
        )}
      </IconButton>
    </>
  )
}

ExaminationRowActions.propTypes = {
  deleteRow: PropTypes.func,
  row: PropTypes.object,
  setComment: PropTypes.func,
}

export default ExaminationRowActions
